(() => {
  const BREAKPOINT = "(min-width: 750px)";

  class CodexYoutubeHybrid extends HTMLElement {
    connectedCallback() {
      this.mobileSlot = this.querySelector('[data-hybrid-slot="mobile"]');
      this.desktopSlot = this.querySelector('[data-hybrid-slot="desktop"]');
      this.mq = window.matchMedia(BREAKPOINT);
      this._onChange = () => this.sync();

      if (typeof this.mq.addEventListener === "function") {
        this.mq.addEventListener("change", this._onChange);
      } else {
        this.mq.addListener(this._onChange);
      }

      this.sync();
    }

    disconnectedCallback() {
      if (!this.mq || !this._onChange) return;
      if (typeof this.mq.removeEventListener === "function") {
        this.mq.removeEventListener("change", this._onChange);
      } else {
        this.mq.removeListener(this._onChange);
      }
    }

    sync() {
      const mode = this.dataset.mode || "dual";
      if (mode !== "dual") {
        this.load(this.mobileSlot || this.desktopSlot);
        return;
      }

      const preferDesktop = this.mq.matches;
      const active = preferDesktop ? this.desktopSlot : this.mobileSlot;
      const inactive = preferDesktop ? this.mobileSlot : this.desktopSlot;
      this.load(active);
      this.unload(inactive);
    }

    load(slot) {
      if (!slot) return;
      const iframe = slot.querySelector("iframe");
      const src = slot.dataset.src;
      if (iframe && src && iframe.getAttribute("src") !== src) {
        iframe.setAttribute("src", src);
      }
    }

    unload(slot) {
      if (!slot) return;
      const iframe = slot.querySelector("iframe");
      if (iframe && iframe.hasAttribute("src")) {
        iframe.removeAttribute("src");
      }
    }
  }

  if (!customElements.get("codex-youtube-hybrid")) {
    customElements.define("codex-youtube-hybrid", CodexYoutubeHybrid);
  }
})();
